import type { AutocompleteRenderOptionState } from '@mui/material';
import type { DirectoryProvider } from '#services/api/provider.ts';

import { Typography } from '@mui/material';

import { getRoleColor } from '../Autocomplete.utils.ts';
import { OptionRow } from '../OptionRow.tsx';

export interface ProviderOptionProps {
  props: Omit<React.HTMLAttributes<HTMLLIElement>, 'key' | 'children'>;
  option: DirectoryProvider;
  state: AutocompleteRenderOptionState;
  /** Set by the virtualized listbox, which owns where in the scroll region the row sits. */
  style?: React.CSSProperties;
}

/**
 * Approximate height of one rendered row. Lives beside the markup it measures because the
 * virtualized listbox positions rows by multiplying it, never by measuring them — so a design change
 * here, or to the shared `OptionRow` shell, that isn't reflected in this number leaves the popup's
 * rows overlapping or gapped.
 */
export const providerOptionHeight = 73;

export function ProviderOption({ props, option, state, style }: ProviderOptionProps) {
  return (
    <OptionRow props={props} selected={state.selected} style={style}>
      <Typography component="div" variant="body2" noWrap>
        {option.name}
      </Typography>
      {option.isUnassigned ? (
        <Typography component="div" variant="caption" noWrap>
          Appointments with no provider assigned
        </Typography>
      ) : (
        <>
          <Typography component="div" variant="caption" noWrap>
            <Typography
              component="span"
              variant="inherit"
              fontWeight={700}
              color={getRoleColor(option.role)}
            >
              {option.role}
            </Typography>
            {option.credential ? ` | ${option.credential}` : null}
          </Typography>
          <Typography component="div" variant="caption" noWrap>
            {option.email}
          </Typography>
        </>
      )}
    </OptionRow>
  );
}
